import BaseButton from 'components/atoms/baseButton';
import { useSetTransferPatients } from 'infrastructure/hooks/patient/use-transfer-patients';
import { type FC } from 'react';

import { useFilter } from './filter/use-filter';
import s from './styles.module.scss';

type Props = {
  onCancel: () => void;
  potentialPatientsCount?: number;
};

export const SubmitAction: FC<Props> = (props) => {
  const { onCancel, potentialPatientsCount } = props;
  const { filter } = useFilter();
  const { setTransferPatients, updateLoading } = useSetTransferPatients({
    onSuccess: onCancel,
  });

  const onSubmit = () => {
    setTransferPatients({
      toAgencyDoctorGuid: filter.toAgencyDoctorGuid,
      fromAgencyDoctorGuid: filter.fromAgencyDoctorGuid,
      patientsCountToTransfer: filter.patientsCountToTransfer,
      filters: {
        clinicGuidsIncluded: filter.clinicGuidsIncluded,
        clinicGuidsExcluded: filter.clinicGuidsExcluded,
        language: filter.language,
        ccm: filter.ccm,
        pcm: filter.pcm,
        newlyEnrolledOnly: filter.newlyEnrolledOnly,
        followUpOnly: filter.followUpOnly,
        partialsOnly: filter.partialsOnly,
      },
    });
  };

  const selectedMoreThanPotential =
    (filter?.patientsCountToTransfer ?? 0) > (potentialPatientsCount ?? 0);

  const someFieldsAreMissing =
    !filter.fromAgencyDoctorGuid ||
    !filter.toAgencyDoctorGuid ||
    !filter.patientsCountToTransfer;

  const submitButtonDisabled =
    someFieldsAreMissing || selectedMoreThanPotential || updateLoading;

  return (
    <div className={s['modal-footer']}>
      <BaseButton
        onClick={onCancel}
        className={s['btn-cancel']}
        label="Cancel"
        disabled={updateLoading}
      />
      <BaseButton
        disabled={submitButtonDisabled}
        onClick={onSubmit}
        label="Transfer Patients"
      />
    </div>
  );
};
